import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';

import { PageRequest } from '@/core/request/PageRequest';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import { WorkOrderTagsQueryFilter } from './WorkOrdersTags.types';
import {
  createWorkOrderTag,
  deleteWorkOrderTag,
  listWorkOrdersTags,
  updateWorkOrderTag,
} from './WorkOrdersTags.service';
import { notification } from 'antd';

export function useWorkOrdersTags(
  params?: WorkOrderTagsQueryFilter,
  enabled?: boolean,
) {
  const query = useInfiniteQuery(
    ['workOrders-tags', { ...params }],
    ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listWorkOrdersTags(req);
    },
    {
      enabled: enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreateWorkOrderTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation(createWorkOrderTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta criada com sucesso',
      });

      await queryClient.invalidateQueries(['workOrders-tags']);

      queryClient.removeQueries(['workOrders-tags']);
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useUpdateWorkOrderTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation(updateWorkOrderTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta editada com sucesso',
      });

      await queryClient.invalidateQueries(['workOrders-tags']);

      queryClient.removeQueries(['workOrders-tags']);
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDeleteWorkOrderTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteWorkOrderTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta excluida com sucesso',
      });

      await queryClient.invalidateQueries(['workOrders-tags']);

      queryClient.removeQueries(['workOrders-tags']);
    },

    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}
